/**
 * The app-level saved-views seam.
 *
 * A table cannot build its own saved-views backing: the source comes from the
 * app's `ApiClient` and the identity from the live session. Declared here once,
 * `<AddressTable enableSavedViews>` and `<TransactionTable enableSavedViews>` are
 * booleans instead of six pages each assembling a source, an identity, a menu and
 * a save dialog — which is why the capability shipped unreachable.
 *
 * Session-scoped on purpose: the identity keys the stored views, so it belongs
 * below `<TenantProvider>` where a tenant switch re-keys it.
 */
import type * as React from "react";
import { SavedViewsProvider } from "@authe/saved-views";
import { useSavedViewsSource } from "@/api/adapters";
import { useStorageIdentity } from "./storageIdentity";

export function DashboardSavedViews({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const source = useSavedViewsSource();
  const identity = useStorageIdentity();
  return (
    <SavedViewsProvider source={source} identity={identity}>
      {children}
    </SavedViewsProvider>
  );
}
